// import ad1 from '../Images/1.jpg';
// import ad2 from '../Images/2.jpg';
// import ad3 from '../Images/1.jpg';
// import ad4 from '../Images/ad4.png';
import React, { useState, useEffect } from 'react';

function Slider() {
    const [index, setIndex] = useState(0);
    const Sliderimgs = [
        '../Images/1.jpg',
        '../Images/2.jpg'
    ];

    const [transitioning, setTransitioning] = useState(false);
    const imageObjects = [];

    // Preload images
    useEffect(() => {
        Sliderimgs.forEach((imgSrc, i) => {
            const img = new Image();
            img.src = imgSrc;
            img.onload = () => {
                imageObjects[i] = img;
            };
        });
    }, [Sliderimgs]);

    function slidenext() {
        if (index < Sliderimgs.length - 1 && !transitioning) {
            setTransitioning(true);
            setIndex((prevIndex) => (prevIndex + 1));
        }
    }

    function slideprev() {
        if (index > 0 && !transitioning) {
            setTransitioning(true);
            setIndex((prevIndex) => (prevIndex - 1));
        }
    }

    useEffect(() => {
        const prevbtn = document.getElementById('prevbtn');
        const nextbtn = document.getElementById('nextbtn');

        if (index < 1) {
            prevbtn.style.visibility = 'hidden';
            nextbtn.style.visibility = 'visible';
        } else if (index === Sliderimgs.length - 1) {
            nextbtn.style.visibility = 'hidden';
            prevbtn.style.visibility = 'visible';
        } else {
            prevbtn.style.visibility = 'visible';
            nextbtn.style.visibility = 'visible';
        }

        const timeout = setTimeout(() => {
            setTransitioning(false);
        }, 1000);

        return () => clearTimeout(timeout);
    }, [index, transitioning]);

    return (
        <>
            <div className={`slider ${transitioning ? 'transitioning' : ''}`} id="slider-container" style={{ backgroundImage: `url(${Sliderimgs[index]})` }}>
                <div className="slider-buttons">
                    <div onClick={slideprev} id='prevbtn'><i className="fas fa-chevron-left"></i></div>
                    <div onClick={slidenext} id='nextbtn'><i className="fas fa-chevron-right"></i></div>
                </div>
                <div className="content">
                    <div>
                        <span>
                            Quality Care,
                        </span>
                    </div>
                    <div>
                        <span>
                            Delivered to
                        </span>
                    </div>
                    <div>
                        <span>
                            Your Doorstep
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Slider;

